import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

type CheckOpenedSettlementResponse = {
  value: boolean;
};

type CheckOpenedSettlementParams = {
  serieDoca: string;
  codDoca: string;
  codEmp: string;
};

export const checkOpenedSettlement = async (
  query: CheckOpenedSettlementParams
): Promise<CheckOpenedSettlementResponse['value']> => {
  try {
    const res = await apiClient.post<CheckOpenedSettlementResponse>(
      Endpoints.LiquidacionesBuscarAbierta,
      {
        serieDoca: query?.serieDoca,
        codDoca: query?.codDoca,
        codEmp: query?.codEmp,
      }
    );

    return !!res?.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
